import React from 'react';
import PropTypes from 'prop-types';
import { PersonIcon, CoinIcon, FootballIcon, VolleyballIcon, TrophyIcon, ClockIcon } from '../../../model/icons';
import { formatDt } from './betUtils';

const SPORT_BET_LABEL = {
    WIN: (bet) => `Победа: ${bet.teamName}`,
    DRAW: () => 'Ничья',
    SPECIFIC_RESULT: (bet) => `Точный счёт: ${bet.specificResult}`
};

const ACTIVITY_BET_LABEL = {
    EVENT_WIN: (bet) => `Победа: ${bet.teamName}`,
    EVENT_TOP_N: (bet) => `Топ-${bet.targetPlace}: ${bet.teamName}`,
    EVENT_EXACT_PLACE: (bet) => `${bet.targetPlace} место: ${bet.teamName}`
};

const SPORT_KIND = {
    FOOTBALL: { label: 'Футбол', Icon: FootballIcon },
    VOLLEYBALL: { label: 'Волейбол', Icon: VolleyballIcon }
};

function describeBet(bet) {
    const map = { ...SPORT_BET_LABEL, ...ACTIVITY_BET_LABEL };
    const fn = map[bet.betType];
    return fn ? fn(bet) : `${bet.betType}: ${bet.teamName || ''}`;
}

function eventContext(bet) {
    const kind = SPORT_KIND[bet.eventType];
    if (kind) return { label: kind.label, Icon: kind.Icon, sub: [bet.team1Name, bet.team2Name].filter(Boolean).join(' — ') };
    return { label: 'Мероприятие', Icon: TrophyIcon, sub: bet.activityEventTitle || '' };
}

// Строка ставки (.br): описание, коэф/выигрыш, игрок, сумма и результат.
// showEvent — показать бейдж типа события и соперников (для таба игроков).
export default function BetRow({ bet, finished, showEvent }) {
    let res;
    if (bet.refunded) res = { cls: 'refund', txt: 'возвращена' };
    else if (!finished) res = { cls: 'pend', txt: 'в игре' };
    else if (bet.isWin) res = { cls: 'win', txt: `+${bet.potentialWin}` };
    else res = { cls: 'lose', txt: `−${bet.amount}` };

    const ctx = showEvent ? eventContext(bet) : null;

    return (
        <div className={`br${bet.refunded ? ' refunded' : ''}`}>
            <div className="br-l">
                {ctx && (
                    <>
                        <div className="br-ev">
                            <span className="br-kind"><ctx.Icon />{ctx.label}</span>
                            {bet.startTime && <span className="br-when"><ClockIcon />{formatDt(bet.startTime)}</span>}
                        </div>
                        {ctx.sub && <div className="br-match">{ctx.sub}</div>}
                    </>
                )}
                <div className="br-t">{describeBet(bet)}</div>
                <div className="br-s">
                    Коэф: <span className="br-val">{Number(bet.coefficient || 0).toFixed(2)}</span>
                    <span className="br-sep"> · </span>
                    Возм. выигрыш: <span className="br-val win">{bet.potentialWin}</span>
                </div>
                {bet.username && !showEvent && <div className="br-u"><PersonIcon />{bet.username}</div>}
            </div>
            <div className="br-r">
                <div className="br-amt">{bet.amount} <CoinIcon /></div>
                <div className={`br-res ${res.cls}`}>{res.txt}</div>
            </div>
        </div>
    );
}

BetRow.propTypes = {
    bet: PropTypes.shape({
        betType: PropTypes.string,
        teamName: PropTypes.string,
        specificResult: PropTypes.string,
        targetPlace: PropTypes.number,
        coefficient: PropTypes.number,
        potentialWin: PropTypes.number,
        amount: PropTypes.number,
        isWin: PropTypes.bool,
        refunded: PropTypes.bool,
        username: PropTypes.string,
        eventType: PropTypes.string,
        team1Name: PropTypes.string,
        team2Name: PropTypes.string,
        activityEventTitle: PropTypes.string,
        startTime: PropTypes.string
    }).isRequired,
    finished: PropTypes.bool,
    showEvent: PropTypes.bool
};

BetRow.defaultProps = { finished: false, showEvent: false };
